import { AspectRatio, Flex, Stack, Text } from '@chakra-ui/react'
import { SectionTitle } from '../section-title'
import { Video } from '../../../../shared/video'

const data = {
  title: 'About Us',
  paragraph1:
    'We saw a wave come towards us, jumped and surfed. Born from a love of music and an anticipation of the future, we at twelve x twelve are a dedicated team based in Berlin, that work towards transforming music into into investable assets and tradable digital collectibles. Our goal is to generate unprecedent value and visibility for all creators.',
  paragraph2:
    'Our name comes from the vinyl. The twelve inch by twelve inch masterpiece that carries both delectable sounds and visuals on its cover, finds itself at the grass root of our cause: in a world of streamed content and blurred ownership, we are shaping the Web 2.5 revolution and hope to reignite appreciation for music in a whole new way.',
}
export const AboutUsHero = () => {
  return (
    <Flex
      direction={{ base: 'column', lg: 'row' }}
      gap={{ base: '4rem', xl: 36 }}
      justify="center"
      align="center"
      bgColor="txtBlack"
      w="full"
      h="full"
      py="4rem"
      px={{ base: '2rem', md: '4rem' }}
    >
      <Stack
        display="flex"
        gap={2}
        alignItems="center"
        w={{ base: 'full', lg: '50%' }}
        order={{ base: 2, lg: 1 }}
      >
        <AspectRatio w="full" maxW="480px" ratio={1} position="relative">
          <Video url="/aboutVideo.mp4" autoStart isLooping />
        </AspectRatio>
      </Stack>
      <Stack gap={16} w={{ base: 'full', lg: '50%' }} order={{ base: 1, lg: 2 }}>
        <SectionTitle title={data.title} />
        <Stack w={{ base: 'full', lg: 'full' }} minW={{ lg: '65%' }} maxW={{ lg: '75%' }}>
          <Text fontSize="lg" color="txtWhite">
            {data.paragraph1}
          </Text>
          <Text fontSize="lg" color="txtWhite">
            {data.paragraph2}{' '}
          </Text>
        </Stack>
      </Stack>
    </Flex>
  )
}
